module.exports = __webpack_public_path__ + "img/open-icon.a361a642.svg";